import DocumentDetails from "../GridDataComponent/DocumentDetails";
import "../../CriminalCertificateValidation.css";

const  Bill = () =>{
  return(
   <DocumentDetails documentType={'eway-bills'} keyAccess={'HawkAI-eWayBill'} title={'Eway Bill'} exportDataToExcelName={'EwayBill Document'} analysefrom={'eway-bill'} deleteText={'eway-bill'} modelName={'doc-ai'} webSocketName={'ewaybill'}/>
  )
 };
 export default Bill;